import { getGeneralAPIRequest } from './apiCommonMethods';
import { allowedIESOSystemIds, allowedNyisoSystemIds, iesoSiteIdToNodeMap } from '../apiConfig';

function buildTimeseriesParams(site, startDate, endDate, points) {
  
  const paramsVar = new URLSearchParams({
    systemId: site. id,
    bin: 'PT15M',
    start: startDate.format(),
    end: endDate.format(),
  });
  points.forEach((p) => paramsVar.append('points', p));
  return paramsVar;
}

export async function fetchSiteStatusChartData(site, startDate, endDate, sessionInfo) {
  if (!site?.id || !sessionInfo) return null;
  const points = ['soc', 'power'];
  if (site.iso !== 'nyiso') points.push('poi_output');

  const axiosSession = getGeneralAPIRequest(sessionInfo);
  const response = await axiosSession.get('/bess/timeseries', {
    params: buildTimeseriesParams(site, startDate, endDate, points)
  });
  return response.data;
}

export async function getEnergyBatteryCapacity(site, startDate, endDate, sessionInfo) {
  if (!allowedIESOSystemIds.has(site.id)) {
    return null;
  }
  if (!site?.id || !sessionInfo) return null;

  const points = ['energy', 'online_battery_capacity'];

  const axiosSession = getGeneralAPIRequest(sessionInfo);
  const response = await axiosSession.get('/bess/timeseries', {
    params: buildTimeseriesParams(site, startDate, endDate, points)
  });
  return response.data;
}


export const getPricingData = async (sessionInfo, site, startDate, endDate) => {
  if (!allowedNyisoSystemIds.has(site.id)) {
    return null;
  }

  const pricingRequest = {
    params: {
      start: startDate.format(),
      end: endDate.format()
    }
  };

  const endpoint = `/prices/nyiso/zones/nyc/timeseries`;

  try {
    const axiosSession = getGeneralAPIRequest(sessionInfo);
    const pricingResponse = await axiosSession.get(endpoint, pricingRequest);
    return pricingResponse.data;
  } catch (err) {
    return null;
  }
};

export const getIesoPricingData = async (sessionInfo, site, startDate, endDate, priceType, productType) => {
  if (!allowedIESOSystemIds.has(site.id)) {
    return null;
  }
  const node = iesoSiteIdToNodeMap[site.id];
  if (!node) return null;

  const pricingRequest = {
    params: {
      start: startDate.format(),
      end: endDate.format(),
      // start: '2025-06-08T00:00:00-04:00',
      // end: '2025-06-09T23:59:59-04:00',
      type: priceType,
      product: productType,
      bin: 'PT1H',
      cached: true
    }
  };

  const endpoint = `/prices/ieso/nodes/${node}/timeseries`;

  try {
    const axiosSession = getGeneralAPIRequest(sessionInfo);
    const pricingResponse = await axiosSession.get(endpoint, pricingRequest);
    return pricingResponse.data;
  } catch (err) {
    return null;
  }
};

export const getScheduleData = async (sessionInfo, site, startDate, endDate, priceType, productType) => {
  if (!allowedIESOSystemIds.has(site.id)) {
    return null;
  }

  const schedulesRequest = {
    params: {
      start: startDate.format(),
      end: endDate.format(),
      systemId: site.id,
      // start: '2025-07-22T00:00:00-05:00',
      // end: '2025-07-23T00:00:00-05:00',
      type: priceType,
      product: productType,
      bin: 'PT1H',
      agg: 'AVG',
      cached: true
    }
  };

  const endpoint = `/market-schedules/ieso`;

  try {
    const axiosSession = getGeneralAPIRequest(sessionInfo);
    const schedulesResponse = await axiosSession.get(endpoint, schedulesRequest);
    return schedulesResponse.data;
  } catch (err) {
    return null;
  }
};


export const getOptimizationData = async (msSessionInfo, site, startDate, endDate, horizon, optim) => {
  const params = {
    type: optim,
    systemId: site.id,
    points: ['power', 'soc'],
    bin: 'PT1H',
    start: startDate.format(),
    end: endDate.format()
  };


  if (horizon) params.horizon = horizon;

  try {
    const axiosSession = getGeneralAPIRequest(msSessionInfo);
    const response = await axiosSession.get(`/optimization/timeseries`, { params });
    return response.data;
  } catch (err) {
    return null;
  }
};


